
export class ScanTicketRequestDto {
  qrCodeString: string;
  danceEventId: string;
}
